import baseApi from '../utils/ApiUtils';

export const conservationApi= (method, payload = null, params = null) => {
  return baseApi(`/conservations/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const conservationAction= (method, id, payload = null, params = null) => {
  return baseApi(`/conservations/${id}/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const conserveActivityLogService= (method, id, payload = null, params = null) => {
  return baseApi(`/conservations/${id}/activity_logs/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const conservationsTaskPoolService= (method, id, payload = null, params = null) => {
  return baseApi(`/conservations/${id}/task_pools/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const conservationsTransition= (method, id, payload = null, params = null) => {
  return baseApi(`/conservations/${id}/transition/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const conservationReportApi = (method, params = null, payload = null) => {
  return baseApi(`reports/conservations/?format=csv`, method, params, payload, 'blob').then(response => {
    return response.data;
  });
};
